// extracted by mini-css-extract-plugin
export default {"container":"IconAndHeading_container__FoMtt","iconBackGround":"IconAndHeading_iconBackGround__I-npA","heading":"IconAndHeading_heading__8k3ir"};